var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Card, Divider, LILAC_300, Typography, WHITE, getTestId, isFirstItem, isLastItem, isValidObject, tokens } from '@airtel/air-design-system';
import { forwardRef, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Dimensions, FlatList, ScrollView, View } from 'react-native';
import { TabsWidgetComponent } from '../../../../components/tabs-widget/TabsWidget';
import { TitleSectionComponent } from '../../../../components/title-section/TitleSection';
import { GridScrollList } from '../grid-scroll-list/GridScrollList';
import { TitleAndBanner } from '../title-and-banner/TitleAndBanner';
import { getDynamicScrollListStyles } from './DynamicScrollListStyles';
import { getRenderListData } from './DynamicScrollListUtils';
export var DynamicScrollList = props => {
  var _a;
  var ComponentToRender = props.childrenToRender,
    _props$showItemSepara = props.showItemSeparator,
    showItemSeparator = _props$showItemSepara === void 0 ? true : _props$showItemSepara,
    _props$pageSize = props.pageSize,
    pageSize = _props$pageSize === void 0 ? 10 : _props$pageSize,
    title = props.title,
    infoTagProps = props.infoTagProps,
    titleStyle = props.titleStyle,
    _props$titleIsBold = props.titleIsBold,
    titleIsBold = _props$titleIsBold === void 0 ? false : _props$titleIsBold,
    id = props.id,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    _props$appendData = props.appendData,
    appendData = _props$appendData === void 0 ? [] : _props$appendData,
    _props$enableStickyFo = props.enableStickyFooter,
    enableStickyFooter = _props$enableStickyFo === void 0 ? false : _props$enableStickyFo,
    listFooterStyle = props.listFooterStyle,
    _props$expandCtaData = props.expandCtaData,
    expandCtaData = _props$expandCtaData === void 0 ? {} : _props$expandCtaData,
    _props$separatorSpace = props.separatorSpace,
    separatorSpace = _props$separatorSpace === void 0 ? 2 : _props$separatorSpace,
    separatorColor = props.separatorColor,
    _props$numberOfColumn = props.numberOfColumn,
    numberOfColumn = _props$numberOfColumn === void 0 ? 1 : _props$numberOfColumn,
    _props$isHorizontalSc = props.isHorizontalScroll,
    isHorizontalScroll = _props$isHorizontalSc === void 0 ? false : _props$isHorizontalSc,
    _props$isHorizontalWi = props.isHorizontalWithoutScroll,
    isHorizontalWithoutScroll = _props$isHorizontalWi === void 0 ? false : _props$isHorizontalWi,
    isGridView = props.isGridView,
    onUserAction = props.onUserAction,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'DynamicScrollList' : _props$testID,
    style = props.style,
    showCard = props.showCard,
    _props$showCardOnFlat = props.showCardOnFlatlist,
    showCardOnFlatlist = _props$showCardOnFlat === void 0 ? false : _props$showCardOnFlat,
    showCallout = props.showCallout,
    showShadow = props.showShadow,
    calloutWidgetProps = props.calloutWidgetProps,
    onCardPressMetaData = props.onCardPressMetaData,
    _props$isSelectable = props.isSelectable,
    isSelectable = _props$isSelectable === void 0 ? false : _props$isSelectable,
    _props$selectableType = props.selectableType,
    selectableType = _props$selectableType === void 0 ? 'single' : _props$selectableType,
    _props$selectableData = props.selectableData,
    selectableData = _props$selectableData === void 0 ? {} : _props$selectableData,
    _props$enableLazyLoad = props.enableLazyLoading,
    enableLazyLoading = _props$enableLazyLoad === void 0 ? true : _props$enableLazyLoad,
    listContainerStyle = props.listContainerStyle,
    listItemContainerStyle = props.listItemContainerStyle,
    tabs = props.tabs,
    _props$tabsMappingToL = props.tabsMappingToList,
    tabsMappingToList = _props$tabsMappingToL === void 0 ? [] : _props$tabsMappingToL,
    cardProps = props.cardProps,
    flatListCardProps = props.flatListCardProps,
    _props$allowOnlySingl = props.allowOnlySingleExpandable,
    allowOnlySingleExpandable = _props$allowOnlySingl === void 0 ? false : _props$allowOnlySingl,
    listHeaderTitle = props.listHeaderTitle,
    listHeaderTitleColor = props.listHeaderTitleColor,
    listHeaderTitleStyle = props.listHeaderTitleStyle,
    _props$showTabs = props.showTabs,
    showTabs = _props$showTabs === void 0 ? true : _props$showTabs,
    _props$shouldUseRecyc = props.shouldUseRecyclerListView,
    shouldUseRecyclerListView = _props$shouldUseRecyc === void 0 ? false : _props$shouldUseRecyc,
    _props$showsVerticalS = props.showsVerticalScrollIndicator,
    showsVerticalScrollIndicator = _props$showsVerticalS === void 0 ? true : _props$showsVerticalS,
    _props$tabChangeListI = props.tabChangeListItemOffset,
    tabChangeListItemOffset = _props$tabChangeListI === void 0 ? 3 : _props$tabChangeListI,
    renderAheadOffset = props.renderAheadOffset,
    animatedScrollViewProps = props.animatedScrollViewProps,
    listBottomOffset = props.listBottomOffset,
    _props$recyclerListVi = props.recyclerListViewStyle,
    recyclerListViewStyle = _props$recyclerListVi === void 0 ? {} : _props$recyclerListVi,
    _props$shouldSetConta = props.shouldSetContainerHeight,
    shouldSetContainerHeight = _props$shouldSetConta === void 0 ? false : _props$shouldSetConta;
  var _useMemo = useMemo(() => {
      if (shouldUseRecyclerListView) {
        return require('recyclerlistview');
      }
      return {};
    }, []),
    RecyclerListView = _useMemo.RecyclerListView,
    DataProvider = _useMemo.DataProvider,
    LayoutProvider = _useMemo.LayoutProvider;
  var _Dimensions$get = Dimensions.get('window'),
    screenWidth = _Dimensions$get.width;
  var _ref = expandCtaData || {},
    _ref$expandedCtaTitle = _ref.expandedCtaTitle,
    expandedCtaTitle = _ref$expandedCtaTitle === void 0 ? 'View More' : _ref$expandedCtaTitle,
    _ref$collapseCtaTitle = _ref.collapseCtaTitle,
    collapseCtaTitle = _ref$collapseCtaTitle === void 0 ? 'Show Less' : _ref$collapseCtaTitle,
    _ref$initialItemCount = _ref.initialItemCount,
    initialItemCount = _ref$initialItemCount === void 0 ? 4 : _ref$initialItemCount,
    _ref$expandedIconName = _ref.expandedIconName,
    expandedIconName = _ref$expandedIconName === void 0 ? 'DownChevronButtonIcon' : _ref$expandedIconName,
    _ref$collapseIconName = _ref.collapseIconName,
    collapseIconName = _ref$collapseIconName === void 0 ? 'UpChevronButtonIcon' : _ref$collapseIconName,
    _ref$accessibilityPro = _ref.accessibilityProps,
    accessibilityProps = _ref$accessibilityPro === void 0 ? {} : _ref$accessibilityPro;
  var setOfVisitedIds = useRef(new Set());
  var _useState = useState({}),
    selectedState = _useState[0],
    setSelectedState = _useState[1];
  var _useState2 = useState(null),
    flatListWidth = _useState2[0],
    setFlatListWidth = _useState2[1];
  var _useState3 = useState(false),
    showFullList = _useState3[0],
    setShowFullList = _useState3[1];
  var dynamicScrollListWidgetStyles = getDynamicScrollListStyles(props, flatListWidth);
  var listRef = useRef();
  var listItemHeights = useRef([]);
  var _useState4 = useState(data),
    itemsArray = _useState4[0],
    setItemsArray = _useState4[1];
  var _useState5 = useState(),
    recyclerViewList = _useState5[0],
    setRecyclerViewList = _useState5[1];
  var renderedData = useMemo(() => getRenderListData(showFullList, itemsArray, initialItemCount), [itemsArray, showFullList]);
  var tabsRef = useRef();
  var visibleItems = useRef([]);
  var disableTabChangeOnScroll = useRef(false);
  var _useState6 = useState(-1),
    currExpandedIndex = _useState6[0],
    setCurrExpandedIndex = _useState6[1];
  var timeoutId;
  var dataProvider = useMemo(() => {
    if (shouldUseRecyclerListView) {
      return new DataProvider((item1, item2) => {
        return item1.id !== item2.id;
      });
    }
  }, []);
  var layoutProvider = useMemo(() => {
    if (shouldUseRecyclerListView) {
      return new LayoutProvider(index => {
        var _a;
        return (_a = recyclerViewList === null || recyclerViewList === void 0 ? void 0 : recyclerViewList.getDataForIndex(index)) === null || _a === void 0 ? void 0 : _a.type;
      }, (_type, dim, index) => {
        var _a;
        dim.width = screenWidth;
        dim.height = (_a = recyclerViewList === null || recyclerViewList === void 0 ? void 0 : recyclerViewList.getDataForIndex(index)) === null || _a === void 0 ? void 0 : _a.height;
        return;
      });
    }
  }, [recyclerViewList]);
  useEffect(() => {
    if (shouldUseRecyclerListView) {
      var dataSet = dataProvider.cloneWithRows(data);
      setRecyclerViewList(dataSet);
    }
  }, []);
  useEffect(() => {
    if (isSelectable && isValidObject(selectableData)) {
      setSelectedState(prevState => {
        if (selectableType === 'multi') {
          var index = selectableData === null || selectableData === void 0 ? void 0 : selectableData.index;
          if (Array.isArray(index)) {
            var newState = {};
            index.forEach(i => newState[i] = !(prevState === null || prevState === void 0 ? void 0 : prevState[i]));
            return Object.assign(Object.assign({}, prevState), newState);
          }
          var value = !(prevState === null || prevState === void 0 ? void 0 : prevState[index]);
          return Object.assign(Object.assign({}, prevState), {
            [index]: value
          });
        } else {
          var _index = selectableData === null || selectableData === void 0 ? void 0 : selectableData.index;
          return {
            [_index]: true
          };
        }
      });
    }
  }, [selectableData]);
  useEffect(() => {
    if ((appendData === null || appendData === void 0 ? void 0 : appendData.length) > 0) {
      setItemsArray(prevData => [...prevData, ...(appendData !== null && appendData !== void 0 ? appendData : [])]);
    }
  }, [appendData]);
  useEffect(() => {
    setItemsArray(data);
    if (shouldUseRecyclerListView) {
      var dataSet = dataProvider.cloneWithRows(data);
      setRecyclerViewList(dataSet);
    }
  }, [data]);
  var scrollListToIndex = data => {
    var _a, _b;
    if ((data === null || data === void 0 ? void 0 : data.index) !== null && (data === null || data === void 0 ? void 0 : data.index) !== undefined && listRef.current) {
      disableTabChangeOnScroll.current = true;
      if (shouldUseRecyclerListView) {
        var listData = recyclerViewList === null || recyclerViewList === void 0 ? void 0 : recyclerViewList.getDataForIndex(data === null || data === void 0 ? void 0 : data.scrollListToIndex);
        if (listData) {
          (_b = (_a = listRef.current).scrollToItem) === null || _b === void 0 ? void 0 : _b.call(_a, listData);
        }
      } else {
        if ((data === null || data === void 0 ? void 0 : data.scrollListToIndex) === 0) {
          listRef.current.scrollToOffset({
            offset: 0,
            animated: true
          });
          return;
        }
        listRef.current.scrollToIndex({
          index: data === null || data === void 0 ? void 0 : data.scrollListToIndex,
          animated: true
        });
      }
    }
  };
  var toggleShowFullList = () => {
    setShowFullList(!showFullList);
  };
  var onListScroll = event => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    (animatedScrollViewProps === null || animatedScrollViewProps === void 0 ? void 0 : animatedScrollViewProps.onScroll) && (animatedScrollViewProps === null || animatedScrollViewProps === void 0 ? void 0 : animatedScrollViewProps.onScroll(event));
    var nativeEvent = event === null || event === void 0 ? void 0 : event.nativeEvent;
    var offsetY = (_b = (_a = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.contentOffset) === null || _a === void 0 ? void 0 : _a.y) !== null && _b !== void 0 ? _b : 0;
    var contentHeight = (_d = (_c = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.contentSize) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : 0;
    var viewportHeight = (_f = (_e = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.layoutMeasurement) === null || _e === void 0 ? void 0 : _e.height) !== null && _f !== void 0 ? _f : 0;
    var currentOffset = 0;
    var itemIndex = 0;
    for (var i = 0; i < itemsArray.length; i++) {
      var itemHeight = ((_g = listItemHeights.current) === null || _g === void 0 ? void 0 : _g[i]) || 0;
      if (offsetY >= currentOffset && offsetY < currentOffset + itemHeight) {
        itemIndex = i;
        break;
      }
      currentOffset += itemHeight;
    }
    if (offsetY + viewportHeight >= contentHeight - 1) {
      (_h = tabsRef.current) === null || _h === void 0 ? void 0 : _h.scrollToIndex(tabsMappingToList[tabsMappingToList.length - 1]);
      return;
    }
    if (tabsRef.current) {
      (_j = tabsRef.current) === null || _j === void 0 ? void 0 : _j.scrollToIndex(tabsMappingToList[itemIndex]);
    }
  };
  var onRecyclerListScroll = event => {
    (animatedScrollViewProps === null || animatedScrollViewProps === void 0 ? void 0 : animatedScrollViewProps.onScroll) && (animatedScrollViewProps === null || animatedScrollViewProps === void 0 ? void 0 : animatedScrollViewProps.onScroll(event));
    if (disableTabChangeOnScroll.current) {
      disableTabChangeOnScroll.current = false;
      return;
    }
    syncTabWithRecyclerScrollList();
  };
  var syncTabWithRecyclerScrollList = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = undefined;
    }
    timeoutId = setTimeout(() => {
      scrollWithRecyclerList();
    }, 75);
  };
  var scrollWithRecyclerList = () => {
    var _a, _b;
    if (((_a = visibleItems.current) === null || _a === void 0 ? void 0 : _a[0]) >= 0) {
      var visibleItemIndex = (data === null || data === void 0 ? void 0 : data.length) >= tabChangeListItemOffset ? visibleItems.current.length - tabChangeListItemOffset : 0;
      var index = visibleItems.current[visibleItemIndex];
      var firstItem = recyclerViewList === null || recyclerViewList === void 0 ? void 0 : recyclerViewList.getDataForIndex(index);
      if (firstItem) {
        var tabIndex = tabsMappingToList[index];
        if (tabIndex >= 0) {
          (_b = tabsRef.current) === null || _b === void 0 ? void 0 : _b.scrollToIndex(tabIndex);
        }
      }
    }
  };
  var renderItem = _ref2 => {
    var _ref2$item = _ref2.item,
      item = _ref2$item === void 0 ? {} : _ref2$item,
      index = _ref2.index;
    var isCurrIndex = index == currExpandedIndex;
    return _jsx(ComponentToRender, Object.assign({}, item, {
      onCardPressMetaData: (item === null || item === void 0 ? void 0 : item.onCardPressMetaData) || onCardPressMetaData,
      onUserAction: onUserAction
    }, isSelectable && {
      [selectableData === null || selectableData === void 0 ? void 0 : selectableData.key]: selectedState === null || selectedState === void 0 ? void 0 : selectedState[index]
    }, {
      withAccordionProps: Object.assign(Object.assign({}, item === null || item === void 0 ? void 0 : item.withAccordionProps), allowOnlySingleExpandable && {
        onPress: () => setCurrExpandedIndex(index),
        isExpanded: isCurrIndex ? true : false
      }),
      style: [{
        borderRadius: showCard ? tokens.spacing.SPACING_16 : tokens.spacing.SPACING_0
      }, item.style]
    }, getTestId(testID + '_' + (index !== null && index !== void 0 ? index : 0).toString())));
  };
  var renderDynamicListItem = _ref3 => {
    var _ref3$item = _ref3.item,
      item = _ref3$item === void 0 ? {} : _ref3$item,
      index = _ref3.index;
    var _a;
    return _jsxs(_Fragment, {
      children: [_jsxs(View, Object.assign({
        style: [isHorizontalScroll && flatListWidth && {
          width: dynamicScrollListWidgetStyles.singleListItemWidth.width
        }, listItemContainerStyle],
        onLayout: event => onItemLayout(event, index)
      }, {
        children: [(item === null || item === void 0 ? void 0 : item.showTitleSection) ? _jsx(TitleSectionComponent, Object.assign({}, item === null || item === void 0 ? void 0 : item.titleSectionProps)) : null, renderItem({
          item,
          index
        })]
      })), (item === null || item === void 0 ? void 0 : item.showDividerBelow) ? _jsx(Divider, Object.assign({}, item === null || item === void 0 ? void 0 : item.itemDividerProps, {
        style: [(_a = item === null || item === void 0 ? void 0 : item.dividerStyle) !== null && _a !== void 0 ? _a : {}]
      })) : null]
    });
  };
  var onViewableItemsChanged = useCallback(info => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    for (var i = 0; i < ((_a = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _a === void 0 ? void 0 : _a.length); i++) {
      var sendImpression = !((_b = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _b === void 0 ? void 0 : _b.has((_c = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _c === void 0 ? void 0 : _c.index));
      if (((_e = (_d = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _d === void 0 ? void 0 : _d[i]) === null || _e === void 0 ? void 0 : _e.index) != null) {
        sendImpression && ((_f = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _f === void 0 ? void 0 : _f.add((_g = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _g === void 0 ? void 0 : _g.index));
        ((_j = (_h = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _h === void 0 ? void 0 : _h[i].item) === null || _j === void 0 ? void 0 : _j.onItemImpression) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, (_l = (_k = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _k === void 0 ? void 0 : _k[i].item) === null || _l === void 0 ? void 0 : _l.onItemImpression), (_m = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _m === void 0 ? void 0 : _m.item));
      }
    }
  }, []);
  var onVisibleIndicesChanged = useCallback(items => {
    if (!items || items.length === 0) return;
    visibleItems.current = items;
    var visibleData = [];
    items.forEach(item => {
      var itemData = recyclerViewList === null || recyclerViewList === void 0 ? void 0 : recyclerViewList.getDataForIndex(item);
      if (itemData) {
        visibleData.push(itemData);
      }
    });
    var visitedIds = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current;
    if (!visitedIds) return;
    visibleData.forEach(data => {
      var index = data.index,
        onItemImpression = data.onItemImpression;
      if (index == null || visitedIds.has(index)) return;
      visitedIds.add(index);
      if (onItemImpression) {
        onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onItemImpression), data);
      }
    });
  }, [recyclerViewList, setOfVisitedIds, onUserAction]);
  var ItemSeparator = () => {
    return _jsx(_Fragment, {
      children: showItemSeparator && (showCard ? _jsx(Divider, {
        color: LILAC_300,
        shadowColor: WHITE,
        height: tokens.spacing.SPACING_2
      }) : _jsx(View, {
        style: {
          width: isHorizontalScroll ? separatorSpace : '100%',
          height: isHorizontalScroll ? '100%' : separatorSpace,
          backgroundColor: separatorColor
        }
      }))
    });
  };
  var onItemLayout = useCallback((event, index) => {
    var _a, _b, _c;
    var height = (_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : 0;
    listItemHeights.current[index] = height;
  }, []);
  var ListFooterComponent = () => {
    return _jsx(_Fragment, {
      children: enableStickyFooter && _jsx(View, Object.assign({
        style: [dynamicScrollListWidgetStyles.ctaOnContainer, listFooterStyle]
      }, {
        children: _jsx(Button, Object.assign({
          buttonType: "tertiary",
          size: "md",
          version: "variable-width",
          iconPosition: "right",
          onPress: toggleShowFullList,
          title: showFullList ? collapseCtaTitle : expandedCtaTitle,
          accessibilityLabel: showFullList ? collapseCtaTitle : expandedCtaTitle,
          iconName: showFullList ? collapseIconName : expandedIconName
        }, getTestId(testID, 'viewMoreLessButton'), accessibilityProps))
      }))
    });
  };
  var flatlistJsx = _jsx(FlatList, Object.assign({
    ref: listRef,
    onLayout: _ref4 => {
      var nativeEvent = _ref4.nativeEvent;
      var _a;
      if (!isGridView && ((_a = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.layout) === null || _a === void 0 ? void 0 : _a.width)) {
        setFlatListWidth(nativeEvent.layout.width);
      }
    },
    data: enableStickyFooter ? renderedData : itemsArray,
    contentContainerStyle: dynamicScrollListWidgetStyles.contentContainer,
    horizontal: isHorizontalScroll,
    renderItem: renderDynamicListItem,
    keyExtractor: (_, index) => "list_item_item_" + index,
    ListHeaderComponent: listHeaderTitle && _jsx(Typography, Object.assign({
      type: 'body-single-line-xs',
      text: listHeaderTitle,
      color: listHeaderTitleColor,
      style: [dynamicScrollListWidgetStyles.listHeaderTitle, listHeaderTitleStyle]
    }, getTestId(testID, 'listHeaderTitle'))),
    ListFooterComponent: enableStickyFooter ? _jsx(ListFooterComponent, {}) : null,
    ItemSeparatorComponent: ItemSeparator,
    onViewableItemsChanged: onViewableItemsChanged,
    showsHorizontalScrollIndicator: false,
    scrollEventThrottle: 16
  }, animatedScrollViewProps, {
    onScroll: onListScroll
  }, getTestId(testID, 'list')));
  var ScrollViewWithHeader = useMemo(() => forwardRef((_a, ref) => {
    var children = _a.children,
      props = __rest(_a, ["children"]);
    return _jsxs(ScrollView, Object.assign({
      ref: ref
    }, props, {
      children: [props === null || props === void 0 ? void 0 : props.headerComponent, children]
    }));
  }), []);
  var recyclerViewJsx = recyclerViewList && _jsx(RecyclerListView, {
    ref: _ => listRef.current = _,
    dataProvider: recyclerViewList,
    layoutProvider: layoutProvider,
    rowRenderer: (_type, data, index) => renderDynamicListItem({
      item: data,
      index: index
    }),
    renderAheadOffset: renderAheadOffset,
    scrollThrottle: 16,
    onScroll: onRecyclerListScroll,
    style: recyclerListViewStyle,
    renderFooter: () => listBottomOffset && _jsx(View, {
      style: {
        height: listBottomOffset
      }
    }),
    onVisibleIndicesChanged: onVisibleIndicesChanged,
    externalScrollView: ScrollViewWithHeader,
    scrollViewProps: Object.assign({
      decelerationRate: 0.8,
      overScrollMode: 'never',
      showsVerticalScrollIndicator: showsVerticalScrollIndicator,
      headerComponent: _jsx(_Fragment, {
        children: listHeaderTitle ? _jsx(Typography, Object.assign({
          type: 'body-single-line-xs',
          text: listHeaderTitle,
          color: listHeaderTitleColor,
          style: [dynamicScrollListWidgetStyles.listHeaderTitle, listHeaderTitleStyle]
        }, getTestId(testID, 'listHeaderTitle'))) : null
      })
    }, animatedScrollViewProps)
  });
  var renderFlatListWithoutCard = () => {
    return _jsxs(_Fragment, {
      children: [_jsx(TitleAndBanner, Object.assign({
        title: title,
        infoTagProps: infoTagProps,
        showCallout: showCallout,
        calloutWidgetProps: calloutWidgetProps,
        onUserAction: onUserAction,
        typoGraphyAndInfotagWrapperStyle: titleStyle,
        isBold: titleIsBold
      }, getTestId(testID, 'TitleAndBanner'))), isHorizontalWithoutScroll ? _jsx(View, Object.assign({
        style: [dynamicScrollListWidgetStyles.listContainer, listContainerStyle]
      }, {
        children: itemsArray === null || itemsArray === void 0 ? void 0 : itemsArray.map(function (item, index) {
          if (item === void 0) {
            item = {};
          }
          return _jsxs(_Fragment, {
            children: [renderDynamicListItem({
              item,
              index
            }), !isFirstItem(index) && !isLastItem(itemsArray, index) && _jsx(ItemSeparator, {})]
          });
        })
      })) : showCardOnFlatlist ? _jsx(Card, Object.assign({}, flatListCardProps, {
        showShadow: showShadow
      }, getTestId(testID, 'flatListWithCard'), {
        children: shouldUseRecyclerListView ? recyclerViewJsx : flatlistJsx
      })) : _jsx(_Fragment, {
        children: shouldUseRecyclerListView ? recyclerViewJsx : flatlistJsx
      })]
    });
  };
  var hasTabs = ((_a = tabs === null || tabs === void 0 ? void 0 : tabs.data) === null || _a === void 0 ? void 0 : _a.length) > 0 && showTabs;
  return _jsxs(View, Object.assign({
    style: [style, (hasTabs || shouldSetContainerHeight) && dynamicScrollListWidgetStyles.container]
  }, getTestId(testID), {
    children: [hasTabs && _jsx(TabsWidgetComponent, Object.assign({
      ref: tabsRef,
      onPressHandler: scrollListToIndex
    }, tabs, {
      onUserAction: onUserAction
    })), (itemsArray === null || itemsArray === void 0 ? void 0 : itemsArray.length) > 0 && (isGridView ? _jsx(GridScrollList, Object.assign({
      title: title,
      infoTagProps: infoTagProps,
      showCallout: showCallout,
      calloutWidgetProps: calloutWidgetProps,
      onUserAction: onUserAction,
      pageSize: pageSize,
      id: id,
      data: itemsArray,
      renderDynamicListItem: renderDynamicListItem,
      separatorSpace: separatorSpace,
      numberOfColumn: numberOfColumn,
      isHorizontalScroll: isHorizontalScroll,
      enableLazyLoading: enableLazyLoading
    }, getTestId(testID, 'gridScrollList'))) : showCard ? _jsx(Card, Object.assign({}, cardProps, {
      showShadow: showShadow
    }, getTestId(testID, 'listWithCard'), {
      children: renderFlatListWithoutCard()
    })) : renderFlatListWithoutCard())]
  }));
};